import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPetsByAccount } from "../../../store/actions/pets-actions";
import {
  setAccountDataRefresh,
  setRetryBillingStatus,
  getAccountInfo
} from "../../../store/actions/accounts-actions";
import {
  getAlertsByAccount,
  setNewRoute
} from "../../../store/actions/alerts-actions";
import { log } from "../../../api/logging-api";
import UpdateBillingView from "./UpdateBillingView.components";
import ManagePaymentsView from "./ManagePaymentsView.component";
import CancelNoUpdateBilling from "./CancelNoUpdateBilling.component";
import { updateBilling } from "../../../api/accounts-api";
import StateList from "../../common/data/StateList";
import UpdateSuccessView from "../../common/update-success-view/UpdateSuccessView";
// import MobileUpdateSuccessView from "../../common/update-success-view/MobileUpdateSuccessView";
import Loader from "../../common/loader/Loader";
import { AppLinks } from "../../../constants/app-links";

import Util from "../../common/util/util";
import { parseQueryString } from "../../common/util/util";

import ModalDialog from "../../common/modal-dialog/ModalDialog";

import "./UpdateBilling.css";
import { store } from "./../../../index";

class UpdateBilling extends Component {
  constructor(props) {
    super(props);
    this.errorText = null;
    this.state = {
      updateBillingSuccess: false,
      serverError: false,
      showSecurityDialog: false,
      showCvvDialog: false,
      sendingToServer: false,
      showUpdateMailingAddress: true,
      inMobileAppWebView: false,
      showManagePayments: false,
      fetchingOneIncCustomerId: false,
      managePaymentsAction: ''
    };
    
    //For google analytics
    window.dataLayer.push({
      'event': 'Pageview',
      'url': window.location.pathname
    });
  }

  componentDidMount() {

    log({
      "level": "Information",
      "message": "Loaded UpdateBilling page",
    });

    window.scrollTo(0, 0);

    this.props.actions.getPetsByAccount();

    /*
    if (window.location.href.toLowerCase().indexOf("mobileappupdatebillinginfo") > -1) {
      this.setState({
        showUpdateMailingAddress: false,
        inMobileAppWebView: true,
      });
    }
    */
  }

  openManagePayments = (action) => {
    this.setState({
      showManagePayments: true,
      managePaymentsAction: action
    });
    return;
  }

  closeManagePayments = () => {
    this.setState({
      showManagePayments: false,
      managePaymentsAction: ''
    });
    return;
  }

  updateBilling = (accountId) => {

    var self = this;
    
    this.setState({
      sendingToServer: true
    });

    updateBilling(accountId)
      .then(response => {

        if (response.data.Item.responseCode != "Success") {
          this.errorText = "An error occurred while updating billing information. Please try again later.";

          log({
            "level": "Error",
            "message": "Error in response from updateBilling: " + response.data.ErrorMessage,
          });
  
          this.setState({
            sendingToServer: false,
            serverError: true
          });
          window.scrollTo(0, 0);
        } else {
            
          setTimeout(() => {

            store.dispatch(setRetryBillingStatus(true));
            store.dispatch(setAccountDataRefresh());
            store.dispatch(getAlertsByAccount());
            
            //For google analytics
            window.dataLayer.push({
              'event': 'Pageview',
              'url': window.location.pathname + '/Confirm'
            });
            
            self.setState({
              updateBillingSuccess : true
            });
          }, process.env.REACT_APP_UPDATE_API_DELAY);

        }
      })
      .catch(error => {
        this.errorText = error && error.errorMessage ? error.errorMessage : "";
        this.setState({
          sendingToServer: false,
          serverError: true
        });
        window.scrollTo(0, 0);
      });
  };
  

  render() {
    var petDetailsText = "";

    if (this.state.updateBillingSuccess) {
      petDetailsText =
        this.props.petDetails && this.props.petDetails.length > 0
          ? Util.getCommaSeperatedNameString(
            this.props.petDetails.map(pet => {
              return pet.Name;
            })
          )
          : "your pets ";
    }

    return (
      <React.Fragment>
        {this.props.userAccountDetails.Status == "Cancel Prorata" || 
          this.props.userAccountDetails.Status == "Cancel Full" ? (
            <CancelNoUpdateBilling
              backToHome={() => {
                this.props.history.push("/");
              }}
            />
          ) : (this.state.updateBillingSuccess ? (
              <UpdateSuccessView
                statusHeader="Your billing information has been updated."
                title="Your policy is active."
                description={
                  "We look forward to protecting " +
                  petDetailsText +
                  "for years to come."
                }
                backToHome={() => {
                  this.props.history.push("/");
                }}
              />
            ) : (!this.state.showManagePayments ?
              (<UpdateBillingView
                userAccountDetails={this.props.userAccountDetails}
                userAccountDetailsFetching={this.props.userAccountDetailsFetching}
                userAccountFetchError={this.props.userAccountFetchError}
                canUserEdit={this.props.canUserEdit}
                errorText={this.errorText}
                openManagePayments={this.openManagePayments}
                sendingToServer={this.state.sendingToServer}
                serverError={this.state.serverError}
                backToHome={() => {
                  this.props.history.push("/");
                }}
              />) :
              (<ManagePaymentsView 
                userAccountDetails={this.props.userAccountDetails}
                managePaymentsAction={this.state.managePaymentsAction}
                closeManagePayments={this.closeManagePayments}
                updateBilling={this.updateBilling.bind(this)}
              />)
            )
          )
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  petDetails: state.pets.petsDetails.filter(pet => pet.Status === "Active"),
  userAccountDetails: state.account.userAccountDetails,
  canUserEdit: state.account.canUserEdit,
  userAccountDetailsFetching: state.account.fetchingAccount,
  userAccountFetchError: state.account.error
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getAccountInfo,
      getPetsByAccount,
      setAccountDataRefresh,
      getAlertsByAccount,
      setNewRoute,
      log,
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateBilling);
